/**
 * Nav - Model File
 * ---
 */

export const navAlertMessage: string =
  'Please access the Historical Report Center for reports and historical ' +
  'periods that have not yet been migrated to our new home.';
